<div class="table-bar-container d-flex mb-2">
    <ng-content />
</div>
